<script setup lang="ts">
import { ref, watchEffect, nextTick } from "vue";
import type { UIMessage } from "ai";
import ChatMessage from "./ChatMessage.vue";

const SCROLL_NEAR_BOTTOM_PX = 100;

const props = withDefaults(
  defineProps<{
    messages: UIMessage[];
    isStreaming: boolean;
    error?: string | null;
  }>(),
  { error: null }
);

defineEmits<{ retry: [] }>();

const containerRef = ref<HTMLElement | null>(null);

function isNearBottom(el: HTMLElement) {
  return el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_NEAR_BOTTOM_PX;
}

watchEffect(async () => {
  void props.messages.length;
  void props.isStreaming;
  void props.error;
  const el = containerRef.value;
  if (!el) return;
  const stick = isNearBottom(el);
  await nextTick();
  if (stick) el.scrollTop = el.scrollHeight;
});
</script>

<template>
  <div
    ref="containerRef"
    class="chat-scroll-area gap-px-16 py-px-24 px-px-16 flex flex-col overflow-y-auto">
    <ChatMessage
      v-for="message in messages"
      :key="message.id"
      :message="message"
      :is-streaming="isStreaming && message.id === messages.at(-1)?.id" />

    <!-- Inline retry CTA when an orphaned user message has no assistant reply -->
    <div
      v-if="error && !isStreaming && messages.at(-1)?.role === 'user'"
      class="gap-px-8 flex items-center justify-end">
      <button
        type="button"
        class="chat-button-subtle gap-px-6 rounded-8 px-px-10 py-px-4 t-caption flex items-center"
        @click="$emit('retry')">
        <font-awesome-icon
          :icon="['fas', 'rotate-right']"
          class="icon-xs" />
        <span>Retry</span>
      </button>
    </div>
  </div>
</template>
